export default __webpack_public_path__ + "static/media/ominous_gathering_stasis_clip.2306eb69.mp3";